import React from 'react';
import Input from '../../../components/UI/Input';
import Modal from '../../../components/UI/Modal';
import { Row, Col } from 'react-bootstrap';

const AddCategoryModal = ({
    handleCategoryImage,
    setParentCategoryId,
    parentCategoryId,
    setCategoryName,
    categoryName,
    categoryList,
    handleClose,
    modalTitle,
    onSubmit,
    show,
    priceCalc,
    setPriceCalc,
    surfaceEditorEnabled,
    setSurfaceEditorEnabled,
}) => {
    return (
        <Modal
            show={show}
            handleClose={handleClose}
            onSubmit={onSubmit}
            modalTitle={modalTitle}
        >
            <Row>
                <Col>
                    <Input
                        value={categoryName}
                        placeholder="Имя категории"
                        onChange={(e) => setCategoryName(e.target.value)}
                        className="form-control-sm"
                    />
                </Col>

                <Col>
                    <select
                        className="form-control form-control-sm"
                        value={parentCategoryId}
                        onChange={(e) => setParentCategoryId(e.target.value)}
                    >
                        <option value="">Выбрать категорию</option>
                        {categoryList.map(option =>
                            <option key={option.value} value={option.value}>{option.name}</option>
                        )}
                    </select>
                </Col>

                <Col>
                    <select
                        className="form-control form-control-sm"
                        value={priceCalc}
                        onChange={(e) => setPriceCalc(e.target.value)}
                    >
                        <option value="piece">Цена за штуку</option>
                        <option value="linearMeter">Цена за погонный метр</option>
                    </select>
                </Col>
            </Row>

            <Row style={{ marginTop: 12 }}>
                <Col>
                    <label
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            margin: 0,
                            fontSize: 14,
                            cursor: 'pointer'
                        }}
                    >
                        <input
                            type="checkbox"
                            checked={surfaceEditorEnabled === true}
                            onChange={(e) => setSurfaceEditorEnabled(e.target.checked)}
                        />
                        <span>Разрешить редактор поверхности</span>
                    </label>

                    <div style={{ fontSize: 12, color: '#777', marginTop: 4 }}>
                        Если включено, в 3D-калькуляторе для товаров этой категории можно будет открывать режим размещения текста, фото и других элементов на поверхности.
                    </div>
                </Col>
            </Row>

            <Row style={{ marginTop: 12 }}>
                <Col>
                    <input type="file" name="categoryImage" onChange={handleCategoryImage} />
                </Col>
            </Row>
        </Modal>
    );
};

export default AddCategoryModal;